var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"musiccontainer _musiccontainer"},[_c('SubNavGuide'),_vm._v(" "),_c('MusicTotalinfo'),_vm._v(" "),_c('GoodsBriefInfo',{attrs:{"isnew":'yes',"goodinfo":'妙得不同凡响。',"goodname":'AirPods Pro',"imgsrc":require('./imgs/airpods_pro.jpg')}}),_vm._v("\\\n "),_c('Device'),_vm._v(" "),_c('ProfessApp'),_vm._v(" "),_c('FinalMusic')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-352eee43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Music/Music.vue
// module id = null
// module chunks = 